<template>
  <div>
    <DashboardHeader title="Manage Staff">
      <HRComponent :branchID="null" :conferenceID="null">
        <template #calendar> <FullCalendar></FullCalendar></template
      ></HRComponent>
    </DashboardHeader>
  </div>
</template>

<script>
import DashboardHeader from "@/components/DashboardHeader.vue";
import HRComponent from "../../../../baron-vue-hr-component/src/App.vue";
import FullCalendar from "@/components/EventsCalendar/FullCalendar.vue";

export default {
  components: {
    DashboardHeader,
    HRComponent,
    FullCalendar,
  },
};
</script>

<style></style>
